import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: `'bricolage'`,
    body: `'bricolage'`,
  },
})

export default theme